import React from "react";
import styles from './horizontalTabs.module.scss';
import {HorizontalTabsDto} from "../../dtos";
import {HorizontalTab} from "./horizontalTab/horizontalTab";
import {useTypedSelector} from "../../hooks/useTypeSelector";

interface Props {
    tabs: HorizontalTabsDto[]
}

export const HorizontalTabs = (props: Props) => {
    const activeTabName = useTypedSelector((state) => state.promotionsAndItems.activeTab);

    const tabs = props.tabs.map((tab, index) => {
        return <HorizontalTab key={index} tab={tab} isActive={activeTabName === tab.name}/>
    })
    return (
        <div className={styles.tabs_wrapper}>
            {tabs}
        </div>
    )
};